import React, { forwardRef, Ref } from "react"
import { Icon, IconProps } from "@mezo-org/mezo-clay"

function VeBTCToken(props: IconProps, ref: Ref<SVGSVGElement>) {
  const { title, size = 24, color, ...restProps } = props

  return (
    <Icon
      ref={ref}
      viewBox="0 0 25 24"
      title={title ?? "veBTC Token"}
      size={size}
      overrides={{
        Svg: {
          style: () => ({
            fill: color ?? "#FF8A00",
          }),
        },
      }}
      role="graphics-symbol"
      {...restProps}
    >
      <circle id="Ellipse 2739" cx="12.5" cy="12" r="12" />
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.22159 15.0711C7.25117 15.1486 7.32551 15.1998 7.40845 15.1998H8.59165C8.67459 15.1998 8.74893 15.1486 8.77851 15.0711L10.6869 10.0711C10.7104 10.0096 10.7021 9.94056 10.6648 9.88637C10.6274 9.83217 10.5659 9.7998 10.5001 9.7998H9.24051C9.15599 9.7998 9.0806 9.85293 9.05217 9.93252L8.36533 11.8551C8.23076 12.225 8.10808 12.6328 8.00005 13.0157C7.89202 12.6328 7.76913 12.2244 7.63456 11.8545L6.94793 9.93252C6.9195 9.85293 6.84411 9.7998 6.75959 9.7998H5.50005C5.43425 9.7998 5.37266 9.83217 5.33533 9.88637C5.29801 9.94056 5.28973 10.0096 5.3132 10.0711L7.22159 15.0711Z"
        fill="white"
      />
      <path
        id="Vector"
        d="M19.8202 9.27867C19.6789 7.80394 18.4061 7.30892 16.7984 7.16754V6.22291H15.5537V7.11365C15.2266 7.11365 14.8922 7.11992 14.5596 7.1262V6.22217H13.3156V7.16644C13.0461 7.1716 11.3905 7.17013 11.3905 7.17013L11.3868 8.26759L12.4256 8.27349V15.4662H11.3872L11.3779 16.5482C11.6795 16.5482 13.0217 16.5541 13.3126 16.5559V17.4884H14.5566V16.5781C14.8977 16.5855 15.2285 16.5884 15.5511 16.5881V17.4888H16.7962V16.5604C18.8896 16.4411 20.3555 15.9144 20.5375 13.9491C20.6851 12.3662 19.941 11.6604 18.7527 11.3732C19.4747 11.004 19.9254 10.358 19.8202 9.27867ZM18.076 13.7021C18.076 15.2484 15.4289 15.0716 14.5843 15.072V12.3307C15.4285 12.3307 18.0746 12.0897 18.0749 13.7021H18.076ZM17.4983 9.83423C17.4983 11.241 15.2894 11.076 14.5862 11.076V8.58948C15.2905 8.58985 17.4991 8.36689 17.4983 9.83423Z"
        fill="white"
      />
    </Icon>
  )
}

export default forwardRef<SVGSVGElement, IconProps>(VeBTCToken)
